import { useQuery } from '@tanstack/react-query'
import { referralsApi } from '@/api/referrals'

/** CrmService's referral program — read-only from the admin side (codes/redemptions come
 * from customer self-service on the storefront, same split as loyalty membership). */
export function useReferralStats() {
  return useQuery({
    queryKey: ['referrals', 'stats'],
    queryFn: () => referralsApi.stats(),
  })
}
